import { render, staticRenderFns } from "./TagCreate.vue?vue&type=template&id=a01e28f2&scoped=true"
import script from "./TagCreate.vue?vue&type=script&lang=js"
export * from "./TagCreate.vue?vue&type=script&lang=js"
import style0 from "./TagCreate.vue?vue&type=style&index=0&id=a01e28f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01e28f2",
  null
  
)

export default component.exports